module.exports = __webpack_public_path__ + "static/media/c40.46646ea8.png";